import { RoutePermittedRole } from '../../@crema/constants/AppEnums';
import AttendanceIcon from '../../assets/leftbar-icon/attendance.svg';
import CompanyIcon from '../../assets/leftbar-icon/company.svg';
import DepartmentIcon from '../../assets/leftbar-icon/department.svg';
import DesignationIcon from '../../assets/leftbar-icon/designation.svg';
import EmployeeMSSIDNIcon from '../../assets/leftbar-icon/employee_mssidn.svg';
import MonitorIcon from '../../assets/leftbar-icon/monitor.svg';
import PoiIcon from '../../assets/leftbar-icon/poi.svg';
import ReportsIcon from '../../assets/leftbar-icon/reports.svg';
import TaskIcon from '../../assets/leftbar-icon/task.svg';
import UserManagementIcon from '../../assets/leftbar-icon/user_management.svg';

const routesConfig = [
  {
    id: 'app',
    title: 'Application 1',
    messageId: '',
    type: 'group',
    children: [
      {
        id: 'monitor',
        title: 'Monitor',
        messageId: 'sidebar.app.dashboard.monitor',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={MonitorIcon}
            alt='Monitor'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/monitor',
      },
      {
        id: 'company',
        title: 'Company',
        messageId: 'sidebar.app.dashboard.company',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
        ],
        icon: (
          <img
            src={CompanyIcon}
            alt='Company'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/company/list',
      },
      {
        id: 'department',
        title: 'Department',
        messageId: 'sidebar.app.dashboard.department',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
        ],
        icon: (
          <img
            src={DepartmentIcon}
            alt='Department'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/department/list',
      },
      {
        id: 'zone',
        title: 'Zone',
        messageId: 'sidebar.app.dashboard.zone',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={DepartmentIcon}
            alt='Department'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/zone/list',
      },

      {
        id: 'designation',
        title: 'Designation',
        messageId: 'sidebar.app.dashboard.designation',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={DesignationIcon}
            alt='Designation'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/designation/list',
      },
      {
        id: 'employeeMssidn',
        title: 'Employee MSISDN',
        messageId: 'sidebar.app.dashboard.employeeMssidn',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={EmployeeMSSIDNIcon}
            alt='Employee MSISDN'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/msisdn/list',
      },
      {
        id: 'userManagement',
        title: 'User Management',
        messageId: 'sidebar.app.dashboard.userManagement',
        type: 'collapse',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
        ],
        icon: (
          <img
            src={UserManagementIcon}
            alt='User Management'
            style={{ width: 16, height: 16 }}
          />
        ),
        // url: "#",
        children: [
          {
            id: 'users',
            title: 'Users',
            messageId: 'sidebar.app.dashboard.userManagement.users',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
            ],
            url: 'user/list',
          },
          {
            id: 'roles',
            title: 'Roles',
            messageId: 'sidebar.app.dashboard.userManagement.roles',
            type: 'item',
            permittedRole: [RoutePermittedRole.SuperAdmin],
            url: 'role/list',
          },
        ],
      },
      {
        id: 'attendance',
        title: 'Attendance',
        messageId: 'sidebar.app.dashboard.attendance',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={AttendanceIcon}
            alt='Attendance'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/attendance/list',
      },
      {
        id: 'task',
        title: 'Task',
        messageId: 'sidebar.app.dashboard.task',
        type: 'collapse',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img src={TaskIcon} alt='Task' style={{ width: 16, height: 16 }} />
        ),
        children: [
          {
            id: 'Task List',
            title: 'Task List',
            messageId: 'sidebar.app.dashboard.task.list',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
              RoutePermittedRole.DepartmentAdmin,
              RoutePermittedRole.ZoneAdmin,
            ],
            icon: (
              <img
                src={TaskIcon}
                alt='Task'
                style={{ width: 16, height: 16 }}
              />
            ),
            url: 'task/list',
          },
          {
            id: 'Task Assign List',
            title: 'Task Assign List',
            messageId: 'sidebar.app.dashboard.task.assign',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
              RoutePermittedRole.DepartmentAdmin,
              RoutePermittedRole.ZoneAdmin,
            ],
            icon: (
              <img
                src={TaskIcon}
                alt='Task'
                style={{ width: 16, height: 16 }}
              />
            ),
            url: 'task-assign-list',
          },
        ],
      },
      {
        id: 'billing',
        title: 'Billing',
        messageId: 'sidebar.app.dashboard.billing',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
         
        ],
        icon: (
          <img src={TaskIcon} alt='Task' style={{ width: 16, height: 16 }} />
        ),
        url: 'billing/list',
      },
      {
        id: 'poi',
        title: 'POI',
        messageId: 'sidebar.app.dashboard.poi',
        type: 'collapse',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: <img src={PoiIcon} alt='POI' style={{ width: 16, height: 16 }} />,
        children: [
          {
            id: 'poi-list',
            title: 'POI List',
            messageId: 'sidebar.app.dashboard.poi.list',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
              RoutePermittedRole.DepartmentAdmin,
              RoutePermittedRole.ZoneAdmin,
            ],
            url: '/poi',
          },
          {
            id: 'poi-create',
            title: 'Create POI',
            messageId: 'sidebar.app.dashboard.poi.create',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
              RoutePermittedRole.DepartmentAdmin,
              RoutePermittedRole.ZoneAdmin,
            ],
            url: '/poi-create',
          },

          {
            id: 'poi-assign-list',
            title: 'List Poi Assignment',
            messageId: 'sidebar.app.dashboard.poi.assignment',
            type: 'item',
            permittedRole: [
              RoutePermittedRole.SuperAdmin,
              RoutePermittedRole.CompanyAdmin,
              RoutePermittedRole.DepartmentAdmin,
              RoutePermittedRole.ZoneAdmin,
            ],
            url: '/poi-assign/list',
          },
        ],
      },
      {
        id: 'report',
        title: 'Report',
        messageId: 'sidebar.app.dashboard.report',
        type: 'item',
        permittedRole: [
          RoutePermittedRole.SuperAdmin,
          RoutePermittedRole.CompanyAdmin,
          RoutePermittedRole.DepartmentAdmin,
          RoutePermittedRole.ZoneAdmin,
        ],
        icon: (
          <img
            src={ReportsIcon}
            alt='Reports'
            style={{ width: 16, height: 16 }}
          />
        ),
        url: '/reports',
      },
    ],
  },
];
export default routesConfig;
